import { render, staticRenderFns } from "./LandingPageModal.vue?vue&type=template&id=353ca038&scoped=true"
import script from "./LandingPageModal.vue?vue&type=script&lang=js"
export * from "./LandingPageModal.vue?vue&type=script&lang=js"
import style0 from "./LandingPageModal.vue?vue&type=style&index=0&id=353ca038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353ca038",
  null
  
)

export default component.exports